<template>
  <div id="app">
    <HomePage :params="$route.params"/>
  </div>
</template>

<script>
import HomePage from './components/HomePage'

export default {
  name: 'App',
  data () {
    return {
      dir:'pulsar',
      lang: 'pl'
    }
  },
  components: {
    HomePage
  },
  methods: {
    getImgaes () {
      console.log(this.$route.params)
      if (this.$route.params && this.$route.params.dir && this.$route.params.lang) {
        this.$store.dispatch('app/get_image_files', {'dir': this.$route.params.dir, 'lang': this.$route.params.lang})
      } else {
        this.$router.push({name: 'HomePage', params: { dir: this.dir, 'lang': this.lang}})
        this.$store.dispatch('app/get_image_files', {'dir': this.dir, 'lang': this.lang})
      }
    }
  },
  created() {
    this.getImgaes()
  }
}
</script>

<style>
html {
  /* overflow: hidden; */
  background: #d3d3d3 !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue